//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'
import RbPlpWishlistModalContent from './rb-plp-wishlist-modal-content.vue'

export default {
  name: 'rb-plp-wishlist-modal',
  components: {
    RbModal,
    RbPlpWishlistModalContent,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
  },
  methods: {
    closeModal() {
      this.visible = false
    },
  },
}
